import type { ReactNode } from 'react';

export interface ListCardProps {
  readonly children: ReactNode;
  readonly className?: string;
}

/**
 * Surface card that holds Row primitives. Provides the surface-1
 * background, rounded corners, and an automatic hairline between
 * adjacent rows via `[&>*+*]:border-t`.
 *
 * No internal padding-top/bottom — the rows themselves carry vertical
 * spacing. Horizontal padding (3.5 = 14px) provides breathing room
 * around row content on the left/right edges.
 */
export function ListCard({ children, className = '' }: ListCardProps) {
  return (
    <div
      className={[
        'rounded-xl bg-surface-1 px-3.5',
        '[&>*+*]:border-t [&>*+*]:border-border-hairline',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
}
